export default {
  common: {
    welcome: 'Willkommen',
    loading: 'Laden...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    search: 'Suchen...',
    filter: 'Filtern',
    export: 'Exportieren',
    refresh: 'Aktualisieren',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    close: 'Schließen',
    actions: 'Aktionen',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    success: 'Erfolg',
    error: 'Fehler',
    warning: 'Warnung',
    info: 'Info',
    apply: 'Anwenden',
    download: 'Herunterladen',
    upload: 'Hochladen',
    view: 'Ansehen',
    details: 'Details',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    country: 'Land',
    city: 'Stadt',
    state: 'Bundesland',
    zipCode: 'Postleitzahl',
    createdAt: 'Erstellt am',
    updatedAt: 'Aktualisiert am',
    description: 'Beschreibung',
    type: 'Typ',
    amount: 'Betrag',
    date: 'Datum',
    time: 'Zeit',
    from: 'Von',
    to: 'Bis',
    all: 'Alle',
    none: 'Keine',
    select: 'Auswählen',
    selected: 'Ausgewählt',
    total: 'Gesamt',
    subtotal: 'Zwischensumme',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    completed: 'Abgeschlossen',
    failed: 'Fehlgeschlagen',
    processing: 'In Bearbeitung',
    cancelled: 'Storniert',
    required: 'Erforderlich',
    optional: 'Optional',
    today: 'Heute',
    yesterday: 'Gestern',
    thisWeek: 'Diese Woche',
    thisMonth: 'Diesen Monat',
    lastMonth: 'Letzten Monat',
    custom: 'Benutzerdefiniert',
    range: 'Bereich',
    noData: 'Keine Daten verfügbar',
    noResults: 'Keine Ergebnisse gefunden',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    expand: 'Erweitern',
    collapse: 'Reduzieren',
    clearAll: 'Alles löschen',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    copyToClipboard: 'In die Zwischenablage kopieren',
    copied: 'Kopiert!',
    notAvailable: 'N/V',
    upgrade: 'Upgraden',
  },
  auth: {
    login: 'Anmelden',
    logout: 'Abmelden',
    email: 'E-Mail',
    password: 'Passwort',
    rememberMe: 'Angemeldet bleiben',
    forgotPassword: 'Passwort vergessen?',
    signIn: 'Einloggen',
    signUp: 'Registrieren',
    loginSuccess: 'Erfolgreich angemeldet',
    loginError: 'Ungültige E-Mail oder Passwort',
    sessionExpired: 'Sitzung abgelaufen. Bitte erneut anmelden.',
    adminPanel: 'Adminbereich',
    needHelp: 'Hilfe benötigt?',
    poweredBy: 'Bereitgestellt von',
  },
  nav: {
    dashboard: 'Dashboard',
    instruments: 'Instrumente',
    clients: 'Kunden',
    accounts: 'Konten',
    trading: 'Handel',
    reports: 'Berichte',
    auditLog: 'Prüfprotokoll',
    withdrawals: 'Auszahlungen',
    deposits: 'Einzahlungen',
    settings: 'Einstellungen',
    plugins: 'Plugins',
    accountGroups: 'Kontogruppen',
    kyc: 'KYC',
    apiDocs: 'API-Docs',
    notifications: 'Benachrichtigungen',
    upgrade: 'Upgraden',
    groupPricing: 'Gruppenpreise',
  },
  dashboard: {
    title: 'Dashboard',
    overview: 'Übersicht',
    stats: 'Statistiken',
    totalClients: 'Gesamtkunden',
    totalAccounts: 'Gesamtkonten',
    openPositions: 'Offene Positionen',
    todayPnL: 'Heutiger G&V',
    liveAccounts: 'Live-Konten',
    demoAccounts: 'Demo-Konten',
    activeClients: 'Aktive Kunden',
    activeTraders: 'Aktive Händler',
    newClients: 'Neue Kunden',
    volumeChart: 'Handelsvolumen (7 Tage)',
    pnlTrend: 'G&V-Trend (30 Tage)',
    recentActivity: 'Letzte Aktivität',
    quickActions: 'Schnellaktionen',
    financialOverview: 'Finanzüberblick',
    financialOverview30Days: 'Finanzüberblick (30 Tage)',
    riskAlerts: 'Risikowarnungen',
    riskDistribution: 'Risikoverteilung',
    currentPlan: 'Aktueller Plan',
    planUsage: 'Plannutzung',
    allowedMarkets: 'Erlaubte Märkte',
    accountOverview: 'Kontenübersicht',
    activeUsers: 'Aktive Benutzer',
    activeThisMonth: 'Diesen Monat aktiv',
    plan: 'Plan',
    feedLatency: 'Feed-Latenz',
    expires: 'Läuft ab',
    cashFlowComparison: 'Cashflow-Vergleich',
    totalTransactions: 'Transaktionen gesamt',
    totalDeposits: 'Einzahlungen gesamt',
    totalWithdrawals: 'Auszahlungen gesamt',
  },
  instruments: {
    title: 'Instrumentenverwaltung',
    library: 'Instrumentenbibliothek',
    enabled: 'Aktivierte Instrumente',
    feed: 'Feed-Instrumente',
    symbol: 'Symbol',
    category: 'Kategorie',
    priceScale: 'Preisskala',
    leverage: 'Hebel',
    spread: 'Spread',
    commission: 'Provision',
    enable: 'Aktivieren',
    disable: 'Deaktivieren',
    bulkEnable: 'Massenaktivierung',
    settings: 'Einstellungen',
    tradeMode: 'Handelsmodus',
    executionType: 'Ausführungstyp',
    forex: 'Forex',
    crypto: 'Krypto',
    stocks: 'Aktien',
    indices: 'Indizes',
    commodities: 'Rohstoffe',
    general: 'Allgemein',
    leverageLots: 'Hebel & Lots',
    spreads: 'Spreads',
    commissions: 'Provisionen',
    riskManagement: 'Risikomanagement',
    advanced: 'Erweitert',
    maxLeverage: 'Maximaler Hebel',
    minLotSize: 'Minimale Lotgröße',
    maxLotSize: 'Maximale Lotgröße',
    lotStep: 'Lot-Schritt',
    spreadType: 'Spread-Typ',
    spreadMarkup: 'Spread-Aufschlag',
    fixedSpread: 'Fester Spread',
    commissionPerLot: 'Provision pro Lot',
    commissionType: 'Provisionstyp',
    stopLevel: 'Stop-Level',
    freezeLevel: 'Freeze-Level',
    maxPositions: 'Maximale Positionen',
    enableSuccess: 'Instrument erfolgreich aktiviert',
    disableSuccess: 'Instrument erfolgreich deaktiviert',
    updateSuccess: 'Einstellungen erfolgreich aktualisiert',
    bulkEnableSuccess: 'Instrumente erfolgreich aktiviert',
  },
  clients: {
    title: 'Kunden',
    clientsList: 'Kundenliste',
    clientDetails: 'Kundendetails',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    country: 'Land',
    kycStatus: 'KYC-Status',
    accountCount: 'Konten',
    totalBalance: 'Gesamtguthaben',
    lastLogin: 'Letzte Anmeldung',
    createdAt: 'Erstellt am',
    verified: 'Verifiziert',
    pending: 'Ausstehend',
    rejected: 'Abgelehnt',
    searchPlaceholder: 'Kunden suchen...',
    nameOrEmail: 'Name oder E-Mail...',
    editClient: 'Kunde bearbeiten',
    configureOverride: 'Benutzerüberschreibung konfigurieren',
    noClientsFound: 'Keine Kunden gefunden',
  },
  accounts: {
    title: 'Konten',
    accountsList: 'Kontenliste',
    accountDetails: 'Kontodetails',
    accountNumber: 'Kontonummer',
    accountType: 'Kontotyp',
    accountGroup: 'Kontogruppe',
    accountSettings: 'Kontoeinstellungen',
    accountState: 'Kontostatus',
    accountActive: 'Konto aktiv',
    balance: 'Guthaben',
    equity: 'Eigenkapital',
    margin: 'Margin',
    freeMargin: 'Freie Margin',
    marginLevel: 'Margin-Level',
    leverage: 'Hebel',
    credit: 'Kredit',
    debit: 'Lastschrift',
    adjustBalance: 'Guthaben anpassen',
    changeLeverage: 'Hebel ändern',
    live: 'Live',
    demo: 'Demo',
    searchPlaceholder: 'Nach Kontonummer oder E-Mail suchen...',
    accountNumberOrEmail: 'Kontonummer oder E-Mail...',
    balanceChange: 'Guthabenänderung',
    reasonForAdjustment: 'Grund für die Anpassung...',
    accountUpdatedSuccess: 'Konto erfolgreich aktualisiert',
    noAccountsFound: 'Keine Konten gefunden',
  },
  trading: {
    title: 'Handel',
    positions: 'Positionen',
    orders: 'Aufträge',
    history: 'Verlauf',
    symbol: 'Symbol',
    side: 'Richtung',
    volume: 'Volumen',
    openPrice: 'Eröffnungspreis',
    currentPrice: 'Aktueller Preis',
    pnl: 'G&V',
    buy: 'Kauf',
    sell: 'Verkauf',
    open: 'Offen',
    pending: 'Ausstehend',
    closed: 'Geschlossen',
    closedAt: 'Geschlossen am',
    openedAt: 'Eröffnet am',
    price: 'Preis',
    totalTrades: 'Trades gesamt',
    winningTrades: 'Gewinnende Trades',
    losingTrades: 'Verlierende Trades',
    totalPnL: 'Gesamt-G&V',
    account: 'Konto',
    status: 'Status',
    swap: 'Swap',
    commission: 'Provision',
    ticket: 'Ticket',
    noPositions: 'Keine offenen Positionen',
    noOrders: 'Keine ausstehenden Aufträge',
    noHistory: 'Kein Handelsverlauf',
    bid: 'Geld',
    ask: 'Brief',
    tradingManagement: 'Handelsverwaltung',
    liveMonitoring: 'Live-Überwachung',
    disconnected: 'Getrennt',
    activeTraders: 'Aktive Händler',
    openPositions: 'Offene Positionen',
    pendingOrders: 'Ausstehende Aufträge',
    floatPnL: 'Schwebender G&V',
    accountState: 'Kontostatus',
    marginCall: 'MARGIN CALL',
    stopOutRisk: 'STOP-OUT-RISIKO',
    live: 'LIVE',
    offline: 'OFFLINE',
    snapshot: 'SCHNAPPSCHUSS',
    marginLvl: 'Margin-Level',
    openTrades: 'Offene Trades',
    freeMargin: 'Freie Margin',
    marginUsed: 'Verwendete Margin',
    balance: 'Guthaben',
    equity: 'Eigenkapital',
    credit: 'Kredit',
    slTp: 'SL / TP',
    fees: 'Gebühren',
    netPnL: 'Netto-G&V',
    grossPnL: 'Brutto-G&V',
    reason: 'Grund',
    openedClosed: 'Eröffnet / Geschlossen',
    closePrice: 'Schlusskurs',
    reserved: 'Reserviert',
    reservedMargin: 'Reservierte Margin',
    created: 'Erstellt',
    triggerPrice: 'Auslösepreis',
    duration: 'Dauer',
    closedTrades: 'Geschlossene Trades',
    activeTrades: 'Aktiv',
    stopLoss: 'Stop Loss',
    takeProfit: 'Take Profit',
    closePosition: 'Position schließen',
    cancelOrder: 'Auftrag stornieren',
    modifyPosition: 'Position ändern',
    thisActionCannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden',
    enterStopLoss: 'Stop Loss-Preis eingeben',
    enterTakeProfit: 'Take Profit-Preis eingeben',
    filterTrading: 'Handel filtern',
    traderSymbolAccount: 'Händler, Symbol, Konto...',
    noFound: 'Keine {tab} gefunden',
    showingOf: 'Zeige {from}–{to} von {total} Händlern',
    traderCount: '{count} Händler · {total} {tab}',
    positionClosedSuccess: 'Position erfolgreich geschlossen',
    orderCancelledSuccess: 'Auftrag erfolgreich storniert',
    positionModifiedSuccess: 'Position erfolgreich geändert',
    failedToClosePosition: 'Position konnte nicht geschlossen werden',
    failedToCancelOrder: 'Auftrag konnte nicht storniert werden',
    failedToModifyPosition: 'Position konnte nicht geändert werden',
    invalidPosition: 'Ungültige Position: ID fehlt',
  },
  reports: {
    title: 'Berichte',
    exposure: 'Expositionsbericht',
    profitability: 'Kundenprofitabilität',
    daily: 'Tagesbericht',
    dateRange: 'Datumsbereich',
    totalExposure: 'Gesamtexposition',
    netVolume: 'Nettovolumen',
    topWinners: 'Top-Gewinner',
    topLosers: 'Top-Verlierer',
    buyVolume: 'Kaufvolumen',
    sellVolume: 'Verkaufsvolumen',
    positionCount: 'Anzahl Positionen',
    winRate: 'Gewinnrate',
    rank: 'Rang',
    client: 'Kunde',
    noData: 'Keine Daten verfügbar',
    totalVolume: 'Gesamtvolumen',
    commission: 'Provision',
    activeAccounts: 'Aktive Konten',
    export: 'Exportieren',
    download: 'Herunterladen',
    positions: 'Positionen',
    trades: 'Trades',
    winning: 'Gewinnend',
    losing: 'Verlierend',
  },
  settings: {
    title: 'Einstellungen',
    brokerInfo: 'Broker-Informationen',
    brokerSettings: 'Broker-Einstellungen',
    brokerName: 'Broker-Name',
    brokerNameRequired: 'Broker-Name *',
    brokerLogo: 'Broker-Logo',
    brokerStatus: 'Broker-Status',
    domain: 'Domain',
    primaryColor: 'Primärfarbe',
    secondaryColor: 'Sekundärfarbe',
    logo: 'Logo',
    supportEmail: 'Support-E-Mail',
    supportPhone: 'Support-Telefon',
    generalInfo: 'Allgemeine Informationen',
    branding: 'Markenidentität',
    accountGroups: 'Kontogruppen',
    addNewGroup: 'Neue Gruppe hinzufügen',
    createFirstGroup: 'Erste Gruppe erstellen',
    noGroupsFound: 'Keine Kontogruppen gefunden',
    default: 'Standard',
    maxLeverage: 'Maximaler Hebel',
    marginCall: 'Margin Call',
    stopOut: 'Stop Out',
    commission: 'Provision',
    maxLotSize: 'Maximale Lotgröße',
    execution: 'Ausführung',
    hedgingAllowed: 'Hedging erlaubt',
    scalpingAllowed: 'Scalping erlaubt',
    eaTrading: 'EA-Handel',
    nbpEnabled: 'NBP aktiviert',
    saving: 'Speichern...',
    groupName: 'Gruppenname',
    description: 'Beschreibung',
    editGroup: 'Gruppe bearbeiten',
    deleteGroup: 'Gruppe löschen',
    cannotDeleteDefault: 'Standardgruppe kann nicht gelöscht werden',
    confirmDelete: 'Möchten Sie "{name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    groupCreatedSuccess: 'Gruppe erfolgreich erstellt',
    groupUpdatedSuccess: 'Gruppe erfolgreich aktualisiert',
    groupDeletedSuccess: 'Gruppe erfolgreich gelöscht',
    failedToSave: 'Gruppe konnte nicht gespeichert werden',
    failedToDelete: 'Gruppe konnte nicht gelöscht werden',
    failedToLoad: 'Kontogruppen konnten nicht geladen werden',
    configureYourBroker: 'Broker-Informationen konfigurieren',
    loadingSettings: 'Einstellungen werden geladen...',
    legalName: 'Firmenname',
    licenseNumber: 'Lizenznummer',
    environment: 'Umgebung',
    contactInformation: 'Kontaktinformationen',
    readOnly: 'Nur lesen',
    readOnlyContactSupport: 'Nur lesen — Support kontaktieren',
    supportedLanguages: 'Unterstützte Sprachen',
    selectLanguagesDescription: 'Sprachen für das Kundenportal auswählen.',
    systemLimits: 'Systemgrenzen',
    maxAccounts: 'Maximale Konten',
    maxConcurrentTrades: 'Maximale gleichzeitige Trades',
    maintenanceMode: 'Wartungsmodus',
    enableMaintenanceMode: 'Wartungsmodus aktivieren',
    maintenanceModeDescription: 'Wenn aktiviert, sehen Kunden die Wartungsnachricht',
    maintenanceMessage: 'Wartungsnachricht',
    maintenanceMessagePlaceholder: 'Wir führen geplante Wartungsarbeiten durch. Bitte versuchen Sie es später.',
    saveChanges: 'Änderungen speichern',
    howToConnectDomain: 'Domain verbinden',
    unlockToEdit: 'Zum Bearbeiten entsperren',
    lockDomain: 'Domain sperren',
    changingDomainWarning: 'Das Ändern der Domain kann den Kundenzugang unterbrechen. Bestätigen?',
    changingDomainWarningLong: 'Das Ändern der Domain kann den Kundenzugang und DNS vorübergehend unterbrechen. Bestätigen?',
    domainBreakWarning: '⚠️ Domainänderung kann Kundenzugang vorübergehend unterbrechen',
    domainBreakWarningLong: '⚠️ Domainänderung kann Kundenzugang und DNS-Routing vorübergehend unterbrechen',
  },
  accountGroups: {
    title: 'Kontogruppen',
    activeGroups: 'aktiv',
    defaultGroups: 'Standard',
    addNewGroup: 'Neue Gruppe hinzufügen',
    createFirstGroup: 'Erste Gruppe erstellen',
    noGroupsFound: 'Keine Kontogruppen gefunden',
    groupDetails: 'Gruppendetails',
    pricingOverrides: 'Preisüberschreibungen',
    riskSettings: 'Risikoeinstellungen',
    tradingSettings: 'Handelseinstellungen',
  },
  groupPricing: {
    title: 'Gruppenpreisüberschreibungen',
    infoBanner: 'Kontogruppen-Preisüberschreibungen',
    infoDescription: 'Benutzerdefinierte Preise für Gruppen konfigurieren. Leer lassen (NULL) für Standardwerte.',
    editPricingOverrides: 'Preisüberschreibungen bearbeiten',
    spreadMarkup: 'Spread-Aufschlag',
    spreadMarkupPips: 'Spread-Aufschlag (Pips)',
    commission: 'Provision',
    commissionPerLot: 'Provision pro Lot (USD)',
    maxLeverageOverride: 'Maximaler Hebelüberschreibung',
    brokerDefault: 'Broker-Standard',
    useBrokerDefault: 'Broker-Standard verwenden',
    clearUseBrokerDefault: 'Löschen (Broker-Standard verwenden)',
    saveOverrides: 'Überschreibungen speichern',
    overridesUpdatedSuccess: 'Gruppenpreisüberschreibungen erfolgreich aktualisiert',
    failedToUpdate: 'Überschreibungen konnten nicht aktualisiert werden',
    leaveEmptyInfo: 'Leer lassen für Broker-Standardwerte.',
    pips: 'Pips',
    perLot: '/Lot',
  },
  kyc: {
    title: 'KYC-Dashboard',
    allKyc: 'Alle KYC',
    allStatus: 'Alle Status',
    allKycStatus: 'Alle KYC-Status',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    verified: 'Verifiziert',
    actionNeeded: 'Aktion erforderlich',
    awaitingAction: 'Warten auf Aktion',
    allCaughtUp: 'Alles auf dem neuesten Stand!',
    noApplications: 'Keine ausstehenden KYC-Anträge.',
    searchPlaceholder: 'Nach Name, E-Mail oder ID suchen...',
    nameEmailOrId: 'ID, Name oder E-Mail...',
    confirmApproval: 'KYC-Genehmigung bestätigen',
    confirmRejection: 'Ablehnung bestätigen — Grund eingeben (erforderlich).',
    rejectionReason: 'Grund für die Ablehnung (erforderlich)',
    approveSuccess: 'KYC erfolgreich genehmigt',
    rejectSuccess: 'KYC erfolgreich abgelehnt',
    failedToApprove: 'KYC konnte nicht genehmigt werden',
    failedToReject: 'KYC konnte nicht abgelehnt werden',
    basicVerified: 'Basisverifizierung',
    fullVerified: 'Vollständige Verifizierung',
    allApplications: 'Alle Anträge',
    kycVerification: 'KYC-Verifizierung',
    reviewManageDesc: 'Verifizierungsanträge prüfen und verwalten',
    pluginSettings: 'Plugin-Einstellungen',
    reviewKycApplication: 'KYC-Antrag prüfen',
    verificationLevel: 'Verifizierungsebene',
    personalInformation: 'Persönliche Informationen',
    fullName: 'Vollständiger Name',
    dateOfBirth: 'Geburtsdatum',
    nationality: 'Nationalität',
    addressLabel: 'Adresse',
    sourceOfFunds: 'Herkunft der Mittel',
    noPersonalData: 'Keine persönlichen Daten eingereicht',
    uploadedDocuments: 'Hochgeladene Dokumente',
    noDocumentsUploaded: 'Keine Dokumente hochgeladen',
    yourDecision: 'Ihre Entscheidung',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    rejectionReasonLabel: 'Ablehnungsgrund',
    submitting: 'Wird übermittelt...',
    submitReview: 'Prüfung einreichen',
    previewNotAvailable: 'Vorschau nicht verfügbar',
    downloadFile: 'Datei herunterladen',
    uploaded: 'Hochgeladen',
    pendingReview: 'Ausstehende Prüfung',
    allLevels: 'Alle Ebenen',
    allStatuses: 'Alle Status',
    allActions: 'Alle Aktionen',
    userCol: 'Benutzer',
    currentLevel: 'Aktuelle Ebene',
    docsCol: 'Dok.',
    lastUpdated: 'Zuletzt aktualisiert',
    levelCol: 'Ebene',
    actionCol: 'Aktion',
    performedBy: 'Durchgeführt von',
    detailsCol: 'Details',
    dateTime: 'Datum & Uhrzeit',
    submittedCol: 'Eingereicht',
    noApplicationsFound: 'Keine Anträge gefunden',
    noAuditRecords: 'Keine Prüfeinträge gefunden',
    noMatchingApplications: 'Keine übereinstimmenden Anträge',
    noPendingApplications: 'Keine ausstehenden Anträge',
    systemAuto: 'System (Auto)',
    admin: 'Admin',
    traderLabel: 'Händler',
    upgradedTo: 'Aufgestuft auf',
    pendingApplications: 'ausstehender Antrag',
    pendingApplicationsPlural: 'ausstehende Anträge',
    users: 'Benutzer',
    usersPlural: 'Benutzer',
    records: 'Eintrag',
    recordsPlural: 'Einträge',
    applications: 'Antrag',
    applicationsPlural: 'Anträge',
    totalUsers: 'Benutzer gesamt',
    basicVerifiedStat: 'Basisverifizierung',
    moderateVerified: 'Moderate Verifizierung',
    fullyVerified: 'Vollständig verifiziert',
    pendingSuffix: '+{count} ausstehend',
    levelBasic: 'Basis',
    levelModerate: 'Moderat',
    levelVerified: 'Verifiziert',
    notStarted: 'Nicht begonnen',
    none: 'Keine',
    unknown: 'Unbekannt',
    review: 'Prüfen',
    auditLog: 'Prüfprotokoll',
    requiredDocuments: 'Erforderliche Dokumente',
    requiredDocsDesc: 'Dokumente für jede KYC-Ebene auswählen.',
    kycDocuments: '{level} KYC-Dokumente',
    selected: '{count} ausgewählt',
    approvalMode: 'Genehmigungsmodus',
    manualReview: 'Manuelle Prüfung',
    autoApprove: 'Automatische Genehmigung',
    autoApproveLevels: 'Ebenen für automatische Genehmigung',
    basicKyc: 'Basis-KYC',
    moderateKyc: 'Moderates KYC',
    verifiedKyc: 'Verifiziertes KYC',
    enforceOnDeposit: 'KYC bei Einzahlungen erforderlich',
    enforceOnWithdrawal: 'KYC bei Auszahlungen erforderlich',
    basic: 'Basis',
    moderate: 'Moderat',
    verified: 'Verifiziert',
    howItWorks: 'Funktionsweise:',
    howItWorksBullet1: 'Beträge unter Basisschwelle: Kein KYC erforderlich',
    howItWorksBullet2: 'Beträge über Basis: Basis-KYC erforderlich',
    howItWorksBullet3: 'Beträge über Moderat: Moderates KYC erforderlich',
    howItWorksBullet4: 'Beträge über Verifiziert: Vollständige Verifizierung erforderlich',
    saveConfiguration: 'Konfiguration speichern',
    savingConfiguration: 'Speichern...',
    openKycDashboard: 'KYC-Dashboard öffnen',
    enableToViewStats: 'Plugin aktivieren um Statistiken zu sehen',
    statNone: 'Keine',
    docGovIdFrontLabel: 'Amtlicher Ausweis (Vorderseite)',
    docGovIdFrontDesc: 'Reisepass, Führerschein oder Personalausweis - Vorderseite',
    docGovIdBackLabel: 'Amtlicher Ausweis (Rückseite)',
    docGovIdBackDesc: 'Rückseite des Ausweises',
    docSelfieLabel: 'Selfie mit Ausweis',
    docSelfieDesc: 'Foto mit Ausweis neben dem Gesicht',
    docProofAddressLabel: 'Adressnachweis',
    docProofAddressDesc: 'Rechnung oder Kontoauszug (< 3 Monate alt)',
    docBankStatementLabel: 'Kontoauszug',
    docBankStatementDesc: 'Aktueller Auszug mit Name und Konto',
    docSourceFundsLabel: 'Herkunft der Mittel',
    docSourceFundsDesc: 'Dokument zum Nachweis der Mittelherkunft',
    docEmploymentLabel: 'Arbeitsbestätigung',
    docEmploymentDesc: 'Bestätigungsschreiben des Arbeitgebers',
    docTaxIdLabel: 'Steueridentifikationsdokument',
    docTaxIdDesc: 'Steueridentifikationsbescheinigung',
    docOtherLabel: 'Sonstige Dokumente',
    docOtherDesc: 'Weitere Nachweisdokumente',
    auditActions: {
      submitted: 'Eingereicht',
      approved: 'Genehmigt',
      rejected: 'Abgelehnt',
      document_uploaded: 'Dok. hochgeladen',
      document_approved: 'Dok. genehmigt',
      document_rejected: 'Dok. abgelehnt',
      level_upgraded: 'Ebene hochgestuft',
      resubmission: 'Erneute Einreichung',
    },
  },
  deposits: {
    title: 'Einzahlungen',
    allDeposits: 'Alle Einzahlungen',
    allStatuses: 'Alle Status',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    completed: 'Abgeschlossen',
    searchPlaceholder: 'Einzahlungen suchen...',
    searchByIdNameEmail: 'Nach ID, Name oder E-Mail suchen...',
    idNameOrEmail: 'ID, Name oder E-Mail...',
    depositProof: 'Einzahlungsnachweis',
    depositProofPdf: 'Einzahlungsnachweis PDF',
    amount: 'Betrag',
    method: 'Methode',
    status: 'Status',
    trader: 'Händler',
    date: 'Datum',
    actions: 'Aktionen',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    confirmApproval: 'Genehmigung bestätigen — dies schreibt dem Händler gut.',
    confirmRejection: 'Ablehnung bestätigen — Grund eingeben (optional).',
    rejectionReason: 'Ablehnungsgrund (optional)...',
    approveSuccess: 'Einzahlung erfolgreich genehmigt',
    rejectSuccess: 'Einzahlung erfolgreich abgelehnt',
    failedToApprove: 'Einzahlung konnte nicht genehmigt werden',
    failedToReject: 'Einzahlung konnte nicht abgelehnt werden',
    noDepositsFound: 'Keine Einzahlungen gefunden',
    proofThumbnail: 'Nachweisvorschau',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    openInNewTab: 'In neuem Tab öffnen',
    bank: 'Bank',
    crypto: 'Krypto',
    card: 'Karte',
    bankPerCountry: 'Bank (pro Land)',
    bankPerUser: 'Bank (pro Benutzer)',
    bankTransfer: 'Banküberweisung',
    bankTransferPerCountry: 'Überweisung (pro Land)',
    bankTransferPerUser: 'Überweisung (pro Benutzer)',
    averageDeposit: 'Durchschnittliche Einzahlung',
  },
  withdrawals: {
    title: 'Auszahlungen',
    allWithdrawals: 'Alle Auszahlungen',
    allStatuses: 'Alle Status',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    completed: 'Abgeschlossen',
    searchPlaceholder: 'Auszahlungen suchen...',
    searchByIdNameEmail: 'Nach ID, Name oder E-Mail suchen...',
    idNameOrEmail: 'ID, Name oder E-Mail...',
    amount: 'Betrag',
    method: 'Methode',
    status: 'Status',
    trader: 'Händler',
    date: 'Datum',
    actions: 'Aktionen',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    confirmApproval: 'Genehmigung bestätigen — Mittel werden freigegeben.',
    confirmWithdrawalApproval: 'Auszahlungsgenehmigung bestätigen — Mittel werden freigegeben.',
    confirmRejection: 'Ablehnung bestätigen — Grund eingeben (optional).',
    rejectionReason: 'Ablehnungsgrund (optional)...',
    approveSuccess: 'Auszahlung erfolgreich genehmigt',
    rejectSuccess: 'Auszahlung erfolgreich abgelehnt',
    failedToApprove: 'Auszahlung konnte nicht genehmigt werden',
    failedToReject: 'Auszahlung konnte nicht abgelehnt werden',
    noWithdrawalsFound: 'Keine Auszahlungen gefunden',
    averageWithdrawal: 'Durchschnittliche Auszahlung',
  },
  auditLog: {
    title: 'Prüfprotokoll',
    allActions: 'Alle Aktionen',
    allEvents: 'Alle Ereignisse',
    allLevels: 'Alle Ebenen',
    searchPlaceholder: 'Protokoll durchsuchen...',
    emailActionOrId: 'E-Mail, Aktion oder ID...',
    event: 'Ereignis',
    user: 'Benutzer',
    action: 'Aktion',
    timestamp: 'Zeitstempel',
    details: 'Details',
    level: 'Ebene',
    info: 'Info',
    warning: 'Warnung',
    error: 'Fehler',
    critical: 'Kritisch',
    noLogsFound: 'Keine Protokolleinträge gefunden',
    administrativeAction: 'Eine administrative Aktion wurde aufgezeichnet.',
    filterAuditLog: 'Prüfprotokoll filtern',
    reset: 'Zurücksetzen',
    eventType: 'Ereignistyp',
    apply: 'Anwenden',
    totalEvents: 'Ereignisse gesamt',
    depositEvents: 'Einzahlungsereignisse',
    withdrawalEvents: 'Auszahlungsereignisse',
    noEventsMatch: 'Keine Ereignisse entsprechen dem Filter',
    noEntriesMatch: 'Keine Einträge entsprechen dem Filter.',
    showAll: 'Alle anzeigen',
    events: 'Ereignis',
    eventsPlural: 'Ereignisse',
    totalEventsRecorded: 'Aufgezeichnete Ereignisse gesamt',
    performedBy: 'Durchgeführt von',
    amount: 'Betrag',
    paymentMethod: 'Zahlungsmethode',
    balanceChange: 'Guthabenänderung',
    statusChange: 'Statusänderung',
    rejectionReason: 'Ablehnungsgrund',
    actionWithdrawalRequested: 'Auszahlung angefordert',
    actionDepositSubmitted: 'Einzahlung eingereicht',
    actionProofUploaded: 'Nachweis hochgeladen',
    actionDepositApproved: 'Einzahlung genehmigt',
    actionDepositRejected: 'Einzahlung abgelehnt',
    actionWithdrawalApproved: 'Auszahlung genehmigt',
    actionWithdrawalRejected: 'Auszahlung abgelehnt',
    actionFundsLocked: 'Mittel gesperrt',
    actionFundsReturned: 'Mittel zurückgegeben',
    fundsLockedSummary: 'Mittel ausstehend für Auszahlungsprüfung gesperrt.',
    fundsReturnedSummary: 'Gesperrte Mittel nach Ablehnung zurückgegeben.',
    depositsTab: 'Einzahlungen',
    withdrawalsTab: 'Auszahlungen',
  },
  plugins: {
    title: 'Plugins',
    backToPlugins: 'Zurück zu Plugins',
    searchPlaceholder: 'Plugins suchen...',
    countrySelectNoMatch: 'Keine Übereinstimmung',
    configurePlugin: 'Plugin konfigurieren',
    pressEscToClose: '{key} zum Schließen drücken',
    loadingUsers: 'Laden...',
    available: 'Verfügbar',
    active: 'Aktiv',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    configure: 'Konfigurieren',
    documentation: 'Dokumentation',
    settings: 'Einstellungen',
    noPluginsFound: 'Keine Plugins gefunden',
    pluginDetails: 'Plugin-Details',
    version: 'Version',
    author: 'Autor',
    description: 'Beschreibung',
    filterInactive: 'Inaktiv',
    paymentGateways: 'Zahlungsanbieter',
    stripeTitle: 'Stripe',
    stripeDescription: 'Zahlungen über Stripe akzeptieren',
    paypalTitle: 'PayPal',
    paypalDescription: 'Zahlungen über PayPal akzeptieren',
    communicationTools: 'Kommunikationstools',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'SMS-Benachrichtigungen senden',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'E-Mail-Zustelldienst',
    bankFieldAccountHolder: 'Kontoinhaber',
    bankFieldBankName: 'Bankname',
    bankFieldAccountNumber: 'Kontonummer',
    bankFieldRoutingNumber: 'Bankleitzahl (optional)',
    bankFieldSetAsDefault: 'Als Standard festlegen',
    copyTradingTitle: 'Copy Trading',
    copyTradingDescription: 'Copy-Trading-Funktionen aktivieren',
    tradingTools: 'Handelstools',
    mam: 'MAM/PAMM',
    apiKey: 'API-Schlüssel',
    apiSecret: 'API-Geheimnis',
    accountSid: 'Konto-SID',
    authToken: 'Auth-Token',
    authDomain: 'Auth-Domain',
    appId: 'App-ID',
    loadingPlugins: 'Plugins werden geladen...',
    noPluginsMatch: 'Keine passenden Plugins',
    tryDifferentSearch: 'Andere Suche versuchen',
    tryAdjustingSearch: 'Suche anpassen',
    activeCount: '{count} aktiv · {owned} eigene · {available} im Shop',
    ofPurchasedActive: 'von {count} gekauften aktiv',
    expired: 'Abgelaufen',
    expires: 'Läuft ab',
    free: 'Kostenlos',
    buyPlugin: 'Kaufen — ${price}{cycle}',
    openInFullPage: 'In Vollseite öffnen',
    noConfigPanel: 'Kein Konfigurationspanel verfügbar.',
    currentStatus: 'Aktueller Status',
    failedToUpdateKyc: 'KYC-Konfiguration konnte nicht aktualisiert werden',
    filterAll: 'Alle',
    filterActive: 'Aktiv',
    filterOwned: 'Eigene',
    filterStore: 'Shop',
    pluginNotFound: 'Plugin nicht gefunden',
    loadingPlugin: 'Plugin wird geladen...',
    failedToLoadPlugin: 'Plugin konnte nicht geladen werden',
    noConfigAvailable: 'Kein Konfigurationspanel verfügbar.',
    activeStatus: 'Aktiv',
    editLabel: 'Bearbeiten',
    newLabel: 'Neu',
    addLabel: 'Hinzufügen',
    saveLabel: 'Speichern',
    cancelLabel: 'Abbrechen',
    globalBankAccount: 'Globales Bankkonto',
    addBankAccount: 'Bankkonto hinzufügen',
    defaultLabel: '(Standard)',
    cryptoWallet: 'Krypto-Wallet',
    addCryptoWallet: 'Krypto-Wallet hinzufügen',
    coinPlaceholder: 'Währung (z.B. BTC)',
    networkPlaceholder: 'Netzwerk (z.B. mainnet)',
    walletAddressPlaceholder: 'Wallet-Adresse',
    labelOptionalPlaceholder: 'Bezeichnung (optional)',
    paymentLink: 'Zahlungslink',
    addPaymentLink: 'Zahlungslink hinzufügen',
    linkNamePlaceholder: 'Name (z.B. Stripe Checkout)',
    perUserBankAccount: 'Bankkonto pro Benutzer',
    addUserBankMapping: 'Benutzer → Bank-Zuordnung hinzufügen',
    editExistingAccount: 'Bestehendes Konto bearbeiten',
    assignedUsers: 'Zugewiesene Benutzer',
    pickTraders: 'Händler auswählen',
    searchAddTrader: 'Händler suchen und hinzufügen...',
    perCountryBankAccount: 'Bankkonto pro Land',
    addCountryBankMapping: 'Land → Bank-Zuordnung hinzufügen',
    mappedCountries: 'Zugeordnete Länder',
    pickCountries: 'Länder auswählen',
    searchAddCountries: 'Länder suchen und hinzufügen...',
    badgeActive: 'Aktiv',
    badgeInactive: 'Inaktiv',
    badgeExpired: 'Abgelaufen',
    purchasePlugin: 'Plugin kaufen',
    paymentMethod: 'Zahlungsmethode',
    generatePaymentAddress: 'Zahlungsadresse generieren',
    sendExactly: 'Genau senden',
    toAddressBelow: 'an die untenstehende Adresse',
    paymentAddress: 'Zahlungsadresse',
    waitingForPayment: 'Warte auf Zahlung...',
    paymentDetected: 'Zahlung erkannt! Bestätigung...',
    confirmationsReceived: '{count} Bestätigung erhalten',
    confirmationsReceivedPlural: '{count} Bestätigungen erhalten',
    expiresIn: 'Läuft ab in:',
    paymentId: 'Zahlungs-ID:',
    paymentConfirmed: 'Zahlung bestätigt!',
    pluginActivated: '{name} wurde aktiviert.',
    networkError: 'Netzwerkfehler. Bitte erneut versuchen.',
    failedToCreatePayment: 'Zahlung konnte nicht erstellt werden',
    paymentExpired: 'Zahlungsfenster abgelaufen. Bitte neue Zahlung erstellen.',
  },
  apiDocs: {
    title: 'API-Dokumentation',
    authentication: 'Authentifizierung',
    baseUrl: 'Basis-URL:',
    allRequestsRequire: 'Alle Anfragen benötigen zwei Header:',
    apiKeyManagement: 'API-Schlüsselverwaltung mit Bereichskontrollen',
    billing: 'Abrechnung',
    apiAccess: 'API-Zugang',
    apiAccessAddon: 'API-Zugangs-Addon aktiv',
    buyAddon: 'Addon kaufen — 199 $/Monat',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'Einzahlungen und Auszahlungen programmatisch genehmigen',
    approveDepositDesc: 'Einzahlung genehmigen (Status muss proof_uploaded sein).',
    approveWithdrawalDesc: 'Ausstehende Auszahlung genehmigen.',
    restApi: 'REST API',
    baseUrlLabel: 'Basis-URL:',
    yourApiKeys: 'Ihre API-Schlüssel',
    noApiKeysYet: 'Keine API-Schlüssel',
    generateNewKey: 'Neuen Schlüssel generieren',
    revokeKey: 'Widerrufen',
    rateLimit: 'Ratenlimit',
    maxKeys: 'Maximale Schlüssel',
    reqPerMin: '{limit} Anf./Min.',
    exampleRequest: 'Beispielanfrage',
    queryParameters: 'Abfrageparameter',
    endpoints: 'Endpunkt',
    endpointsPlural: 'Endpunkte',
    includedInPlan: 'Im Enterprise-Plan enthalten',
    addonActive: 'API-Zugangs-Addon aktiv',
    restApiAccess: 'REST API-Zugang',
    restApiDesc: 'REST API-Zugang im Enterprise-Plan oder als Addon verfügbar.',
    featureReadClients: 'Kunden, Konten und Handelsverlauf lesen',
    featureApprovePayments: 'Einzahlungen und Auszahlungen programmatisch genehmigen',
    featureApiKeyManagement: 'API-Schlüsselverwaltung mit Bereichskontrollen',
    featureRateLimit: 'Bis zu 60 Anfragen pro Minute pro Schlüssel',
    featureInteractiveDocs: 'Interaktive Dokumentation im Dashboard',
    upgradeToEnterprise: 'Auf Enterprise upgraden',
    buyAddonPrice: 'Addon kaufen — 199 $/Monat',
    generateApiKey: 'API-Schlüssel generieren',
    keyName: 'Schlüsselname',
    keyNamePlaceholder: 'z.B. Produktionsschlüssel',
    scopes: 'Bereiche',
    generating: 'Generieren...',
    generateKey: 'Schlüssel generieren',
    keyGenerated: 'Schlüssel generiert',
    copySecretWarning: '⚠️ Geheimnis jetzt kopieren — wird nicht erneut angezeigt.',
    apiKeyLabel: 'API-Schlüssel',
    apiSecretLabel: 'API-Geheimnis',
    done: 'Fertig',
    enterKeyName: 'Schlüsselnamen eingeben',
    failedToCreateKey: 'Schlüssel konnte nicht erstellt werden',
    keyRevoked: 'Schlüssel widerrufen',
    confirmRevoke: 'Diesen API-Schlüssel widerrufen? Nicht rückgängig machbar.',
  },
  notifications: {
    title: 'Benachrichtigungseinstellungen',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    smsNotifications: 'SMS-Benachrichtigungen',
    pushNotifications: 'Push-Benachrichtigungen',
    deposits: 'Einzahlungen',
    withdrawals: 'Auszahlungen',
    newClients: 'Neue Kunden',
    kycApplications: 'KYC-Anträge',
    systemAlerts: 'Systemwarnungen',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    saveSettings: 'Einstellungen speichern',
    settingsSaved: 'Einstellungen gespeichert',
    notificationChannels: 'Benachrichtigungskanäle',
    configureChannels: 'Konfigurieren, wie die Plattform Alerts an Kunden sendet.',
    saveAll: 'Alle speichern',
    saving: 'Speichern...',
    enableToConfigure: 'Aktivieren um {title} zu konfigurieren',
    emailSmtp: 'E-Mail (SMTP)',
    emailSmtpSubtitle: 'E-Mails über eigenen SMTP-Server senden',
    recommended: 'Empfohlen',
    smtpHost: 'SMTP-Host',
    smtpPort: 'SMTP-Port',
    usernameEmail: 'Benutzername / E-Mail',
    passwordAppPassword: 'Passwort / App-Passwort',
    fromEmail: 'Absender-E-Mail',
    fromName: 'Absendername',
    useTls: 'TLS / STARTTLS verwenden',
    useTlsHint: 'Empfohlen für Port 587.',
    sendTestEmail: 'Test-E-Mail senden',
    pushFcm: 'Push-Benachrichtigungen (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging für Android, iOS und Web',
    pushSetupRequired: 'Einrichtung erforderlich',
    pushSetupDesc: 'Firebase Console → Projekteinstellungen → Dienstkonten aufrufen.',
    serviceAccountCredentials: 'Dienstkonto-Anmeldedaten',
    clientTokenStatus: 'Client-Token-Status',
    clientTokenDesc: 'Push-Tokens werden bei der Anmeldung automatisch registriert.',
    testPush: 'Push testen',
    webAppConfig: 'Web-App-Konfiguration',
    webAppConfigured: 'Konfiguriert — {project}',
    webAppRequired: 'Für Browser- und Mobile-Push erforderlich',
    webAppWhereToFind: 'Wo diese Daten zu finden sind',
    webAppWhereToFindDesc: 'Firebase Console → Projekteinstellungen → Ihre Apps',
    saveWebConfig: 'Web-Konfiguration speichern',
    vapidKey: 'VAPID-Schlüssel',
    vapidKeyHint: '— Cloud Messaging-Tab → Web Push-Zertifikate',
    credentialsOnFile: 'Anmeldedaten vorhanden',
    credentialsStoredSecurely: 'Sicher auf dem Server gespeichert',
    replaceCredentials: 'Ersetzen',
    uploadServiceAccount: 'Dienstkonto-JSON hochladen',
    uploadServiceAccountHint: 'Klicken zum Auswählen — wird validiert und sicher gespeichert',
    uploadingValidating: 'Hochladen und validieren...',
    uploadSuccess: 'Firebase-Anmeldedaten erfolgreich hochgeladen',
    uploadFailed: 'Fehler — gültige Firebase-JSON prüfen',
    saveWebConfigSuccess: 'Firebase Web-Konfiguration gespeichert',
    saveWebConfigFailed: 'Web-Konfiguration konnte nicht gespeichert werden',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'SMS über Twilio an Kunden senden',
    smsSetupRequired: 'Einrichtung erforderlich',
    smsSetupDesc: 'Anmeldedaten von console.twilio.com holen',
    accountSid: 'Konto-SID',
    accountSidHint: 'Beginnt mit AC...',
    authToken: 'Auth-Token',
    fromPhoneNumber: 'Absendertelefonnummer',
    fromPhoneHint: 'E.164-Format, z.B. +4915123456789',
    sendTestSms: 'Test-SMS senden',
    statusConnected: 'Verbunden',
    statusError: 'Fehler',
    statusUntested: 'Nicht getestet',
    statusTesting: 'Testen...',
    notificationRouting: 'Benachrichtigungsweiterleitung',
    notificationRoutingDesc: 'Kanäle für jeden Benachrichtigungstyp wählen',
    noChannelsEnabled: 'Keine Kanäle aktiviert',
    noChannelsEnabledDesc: 'Mindestens einen Kanal aktivieren',
    notifMarginCall: 'Margin Call',
    notifMarginCallDesc: 'Wenn Margin-Level unter Schwelle fällt',
    notifLiquidation: 'Liquidation',
    notifLiquidationDesc: 'Wenn Positionen zwangsgeschlossen werden',
    notifDeposit: 'Einzahlung',
    notifDepositDesc: 'Wenn eine Einzahlung bestätigt wird',
    notifWithdrawal: 'Auszahlung',
    notifWithdrawalDesc: 'Wenn eine Auszahlung verarbeitet wird',
    notifTradeOpened: 'Trade eröffnet',
    notifTradeOpenedDesc: 'Wenn eine neue Position eröffnet wird',
    notifTradeClosed: 'Trade geschlossen',
    notifTradeClosedDesc: 'Wenn eine Position geschlossen wird',
    failedToLoad: 'Einstellungen konnten nicht geladen werden',
    failedToSave: 'Speichern fehlgeschlagen',
    testSuccess: '{channel}-Test erfolgreich — Posteingang prüfen',
    testFailed: '{channel}-Test fehlgeschlagen',
  },
  upgrade: {
    title: 'Plan upgraden',
    currentPlan: 'Aktueller Plan',
    choosePlan: 'Plan wählen',
    basic: 'Basis',
    professional: 'Professionell',
    enterprise: 'Enterprise',
    perMonth: '/Monat',
    perYear: '/Jahr',
    monthly: 'Monatlich',
    annually: 'Jährlich',
    features: 'Funktionen',
    selectPlan: 'Plan auswählen',
    currentPlanLabel: 'Aktueller Plan',
    upgradeTo: 'Upgraden auf',
    contactSales: 'Vertrieb kontaktieren',
    unlimitedClients: 'Unbegrenzte Kunden',
    unlimitedAccounts: 'Unbegrenzte Konten',
    advancedReporting: 'Erweiterte Berichte',
    prioritySupport: 'Prioritätssupport',
    apiAccess: 'API-Zugang',
    customBranding: 'Benutzerdefiniertes Branding',
    whiteLabel: 'White Label',
    dedicatedManager: 'Dedizierter Account-Manager',
    upgradeAvailable: 'Upgrade verfügbar',
    plan: 'Plan',
    unlock: 'Freischalten',
    apiAccessFeature: ', API-Zugang',
    andMore: '& mehr',
    renew: 'Verlängern',
  },
  theme: {
    light: 'Heller Modus',
    dark: 'Dunkler Modus',
    toggle: 'Thema wechseln',
  },
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Sprache auswählen',
  },
  errors: {
    general: 'Etwas ist schiefgelaufen',
    networkError: 'Netzwerkfehler. Verbindung prüfen.',
    unauthorized: 'Nicht autorisiert. Bitte erneut anmelden.',
    forbidden: 'Zugriff verweigert.',
    notFound: 'Ressource nicht gefunden.',
    serverError: 'Serverfehler. Bitte später erneut versuchen.',
    actionFailed: 'Aktion fehlgeschlagen',
  },
  success: {
    saved: 'Erfolgreich gespeichert',
    updated: 'Erfolgreich aktualisiert',
    deleted: 'Erfolgreich gelöscht',
    created: 'Erfolgreich erstellt',
    copied: 'In Zwischenablage kopiert',
  },
  time: {
    seconds: 'Sekunden',
    minutes: 'Minuten',
    hours: 'Stunden',
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    years: 'Jahre',
    ago: 'vor',
    justNow: 'gerade eben',
    today: 'Heute',
    yesterday: 'Gestern',
    tomorrow: 'Morgen',
  },
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'Lot',
    lots: 'Lots',
    pips: 'Pips',
    percent: '%',
  },
  cascade: {
    settingsArchitecture: 'Einstellungsarchitektur',
    title: 'Kaskaden-Prioritätssystem',
    subtitle: 'Einstellungen werden von höchster → niedrigster Priorität aufgelöst. Feld leer lassen',
    subtitleNull: '(NULL)',
    subtitleFallthrough: 'um diese Ebene zu überspringen.',
    resolutionOrder: 'Auflösungsreihenfolge:',
    firstNonNull: 'Erster Nicht-Null-Wert gewinnt',
    highestPriority: 'Höchste Priorität — Klicken zum Erkunden',
    ifEmptyFallsThrough: '↓ wenn leer, fällt durch',
    priority: 'Priorität',
    leaveFieldEmpty: 'Feld leer lassen (NULL)',
    skipLayer: 'um diese Ebene zu überspringen',
    finalFallback: 'Letzter Rückgriff — keine Ebene darunter.',
    hardLimitsNote: 'Felder mit',
    hardLimitsNote2: 'sind systemweite strikte Limits.',
    layers: {
      userOverride: 'Benutzerüberschreibung',
      userSublabel: 'Sonderkonditionen pro Kunde',
      userTooltip: 'Höchste Priorität. Jedes hier gesetzte Feld übertrifft alles andere.',
      userFallsTo: 'Kontogruppe (P2)',
      accountGroup: 'Kontogruppe',
      groupSublabel: 'VIP-, Standard-, Professionell-Stufen',
      groupTooltip: 'Gilt für alle Kunden dieser Gruppe.',
      groupFallsTo: 'Symboleinstellungen (P3)',
      symbolSettings: 'Symboleinstellungen',
      symbolSublabel: 'Broker-Konfiguration pro Instrument',
      symbolTooltip: 'Steuert Preis- und Ausführungsregeln pro Instrument.',
      symbolFallsTo: 'Plattformstandards (P4)',
      platformDefaults: 'Plattformstandards',
      platformSublabel: 'System-Fallback & strikte Limits',
      platformTooltip: 'Niedrigste Priorität, erzwingt aber absolute Grenzen.',
    },
    setByBroker: 'Vom Broker festgelegt',
    setBySystemAdmin: 'Vom Systemadministrator festgelegt',
    goToClients: 'Zu Kunden',
    goToAccountGroups: 'Zu Kontogruppen',
    goToInstruments: 'Zu Instrumenten',
    fields: {
      maxLeverage: 'Maximaler Hebel',
      maxLotSize: 'Maximale Lotgröße',
      marginCallLevel: 'Margin-Call-Level',
      stopOutLevel: 'Stop-Out-Level',
      maxOpenPositions: 'Maximale offene Positionen',
      commissionPerLot: 'Provision pro Lot',
      tradingDisabled: 'Handel deaktiviert',
      spreadMarkup: 'Spread-Aufschlag',
      swapMarkup: 'Swap-Aufschlag',
      tripleSwapDay: 'Dreifacher Swap-Tag',
      stopLevel: 'Stop-Level',
      freezeLevel: 'Freeze-Level',
      defaultLeverage: 'Standard-Hebel',
      defaultCommission: 'Standard-Provision',
      defaultMarginCall: 'Standard-Margin-Call',
      defaultStopOut: 'Standard-Stop-Out',
      maxLeverageCap: 'Maximaler Hebeldeckel',
      minMarginCall: 'Minimaler Margin-Call',
      minStopOut: 'Minimaler Stop-Out',
      maxCommissionCap: 'Maximaler Provisionsdeckel',
      maxPositionsCap: 'Maximaler Positionsdeckel',
    },
    fieldDescs: {
      capLeverageClient: 'Hebel für diesen Kunden begrenzen',
      limitPositionSize: 'Positionsgröße pro Trade begrenzen',
      overrideAlertThreshold: 'Warnschwelle überschreiben',
      overrideAutoClose: 'Auto-Close-Schwelle überschreiben',
      limitConcurrentTrades: 'Gleichzeitige Trades begrenzen',
      customCommission: 'Benutzerdefinierter Provisionssatz',
      killSwitch: 'Notausschalter für diesen Kunden',
      groupCommission: 'Gruppen-Provisionssatz',
      groupLeverage: 'Gruppen-Hebeldeckel',
      groupMarginCall: 'Gruppen-Warnschwelle',
      groupStopOut: 'Gruppen-Auto-Close-Schwelle',
      groupPositions: 'Gruppen-Positionslimit',
      groupLotSize: 'Gruppen-Handelsgrößenlimit',
      pipsAddedSpread: 'Pips zum Rohspread hinzugefügt',
      symbolCommission: 'Symbol-spezifische Provision',
      overnightSwap: 'Zu Overnight-Swap-Sätzen hinzugefügt',
      tripleSwapDay: 'Tag, an dem dreifacher Swap berechnet wird',
      symbolLeverage: 'Symbol-Hebeldeckel',
      symbolLotSize: 'Symbol-Handelsgrößenlimit',
      minSlTpDistance: 'Minimaler SL/TP-Abstand in Pips',
      modificationFreeze: 'Änderungs-Freeze-Abstand',
      fallbackLeverage: 'Fallback-Hebel',
      fallbackCommission: 'Fallback-Provision',
      fallbackMarginCall: 'Fallback-Margin-Call',
      fallbackStopOut: 'Fallback-Stop-Out',
      hardCeilingLeverage: 'Striktes Limit — keine Ebene kann überschreiten',
      hardFloorMarginCall: 'Strikter Boden — keine Ebene kann unterschreiten',
      hardFloorStopOut: 'Strikter Boden — keine Ebene kann unterschreiten',
      hardCeilingCommission: 'Strikter Provisionsdeckel',
      systemPositionLimit: 'Systemweites Positionslimit',
    },
  },
  emailTemplates: {
    loadingTemplates: 'Vorlagen werden geladen...',
    loadingTemplate: 'Vorlage wird geladen...',
    retry: 'Erneut versuchen',
    allTemplates: '← Alle Vorlagen',
    customised: 'Angepasst',
    custom: 'Angepasst',
    default: 'Standard',
    subjectLine: 'Betreffzeile',
    subjectPlaceholder: 'E-Mail-Betreff...',
    editorTab: 'Editor',
    htmlTab: 'HTML',
    previewTab: 'Vorschau',
    variables: 'Variablen:',
    showLess: 'Weniger anzeigen',
    clickToInsert: 'Klicken zum Einfügen einer Variable:',
    saveTemplate: 'Vorlage speichern',
    savingTemplate: 'Speichern...',
    resetToDefault: 'Auf Standard zurücksetzen',
    resetting: 'Zurücksetzen...',
    back: 'Zurück',
    resetConfirm: 'Auf Standard-Vorlage zurücksetzen? Anpassungen gehen verloren.',
    subjectBodyRequired: 'Betreff und Inhalt sind erforderlich',
    activeBranding: 'Aktives Branding',
    companyName: 'Firmenname',
    primaryColor: 'Primärfarbe',
    logoUrl: 'Logo-URL',
    noLogoSet: 'Kein Logo festgelegt',
    emailFooter: 'E-Mail-Fußzeile',
    brandingNote: 'Für Branding-Updates zu Broker-Einstellungen wechseln.',
    editBranding: 'Branding bearbeiten',
    closeBranding: 'Branding schließen',
    templateListDesc: 'Vorlage anklicken zum Bearbeiten.',
    templateInfoNote: 'Mit "Standard" gekennzeichnete Vorlagen verwenden das integrierte Design mit Ihrem Branding.',
    loadingBranding: 'Branding wird geladen...',
    typeDepositApproved: 'Einzahlung genehmigt',
    typeDepositRejected: 'Einzahlung abgelehnt',
    typeWithdrawalApproved: 'Auszahlung genehmigt',
    typeWithdrawalRejected: 'Auszahlung abgelehnt',
    typeMarginCall: 'Margin Call',
    typeLiquidation: 'Konto liquidiert',
    typeKycApproved: 'KYC genehmigt',
    typeKycRejected: 'KYC abgelehnt',
    typeWelcome: 'Willkommens-E-Mail',
  },
  credits: {
    activeRules: 'Aktive Regeln',
    totalAwarded: 'Gesamt vergeben',
    awardEvents: 'Vergabe-Ereignisse',
    bonusRules: 'Bonusregeln',
    awardHistory: 'Vergabehistorie',
    newRule: 'Neue Regel',
    manualAward: 'Manuelle Vergabe',
    noBonusRules: 'Keine Bonusregeln. Fügen Sie eine hinzu.',
    noCreditAwards: 'Keine Kreditvergaben.',
    deactivateConfirm: 'Diese Regel deaktivieren?',
    revokeReason: 'Widerrufsgrund (optional):',
    operationFailed: 'Vorgang fehlgeschlagen',
    bonusRuleTitle: '{mode} Bonusregel',
    ruleName: 'Regelname (z.B. Willkommensbonus)',
    percentOfDeposit: '% der Einzahlung (z.B. 20)',
    fixedAmountUsd: 'Fester Betrag (USD)',
    maxCreditCap: 'Maximales Kreditlimit (optional)',
    minDepositQualify: 'Mindesteinzahlung zur Qualifizierung',
    expiresAfterDays: 'Läuft nach N Tagen ab (optional)',
    ruleActive: 'Aktiv — automatische Vergabe bei qualifizierenden Einzahlungen',
    ruleDisabled: 'Deaktiviert',
    savingDots: 'Speichern...',
    awardingDots: 'Vergeben...',
    manualCreditAward: 'Manuelle Kreditvergabe',
    accountId: 'Konto-ID',
    userId: 'Benutzer-ID',
    amountUsd: 'Betrag (USD)',
    notesOptional: 'Notizen (optional)',
    awardCredit: 'Kredit vergeben',
    infoWelcomeDeposit: 'WELCOME- und DEPOSIT-Regeln werden automatisch bei Einzahlungsgenehmigung ausgelöst.',
    bonusWelcome: 'Willkommen',
    bonusDeposit: 'Einzahlung',
    bonusGoodwill: 'Kulanz',
    bonusPromotion: 'Promotion',
    statusRevoked: 'Widerrufen',
    statusExpired: 'Abgelaufen',
  },
  pages: {
    websitePages: 'Website-Seiten',
    websitePagesDesc: 'Website aufbauen und verwalten.',
    pluginNotActive: 'Plugin nicht aktiv.',
    viewPlugins: 'Plugins anzeigen',
    mainPages: 'Hauptseiten',
    legalPages: 'Rechtliche Seiten',
    langs: 'Sprachen',
    save: 'Speichern',
    saved: 'Gespeichert',
    error: 'Fehler',
    publish: 'Veröffentlichen',
    unpublish: 'Veröffentlichung aufheben',
    published: 'Veröffentlicht',
    draft: 'Entwurf',
    tabBlocks: 'Blöcke',
    tabSeo: 'SEO',
    addBlock: 'Block hinzufügen',
    addFirstBlock: 'Ersten Block hinzufügen',
    addFirstBlockHint: 'Ersten Inhaltsblock hinzufügen',
    noBlocks: 'Keine Blöcke',
    pageTitle: 'Seitentitel',
    pageTitleHint: 'Haupttitel in Navigation und Seitenkopf',
    translatable: 'Übersetzbar',
    pageSlug: 'Seiten-Slug',
    seoTitle: 'SEO-Titel',
    seoDescription: 'SEO-Beschreibung',
    googlePreview: 'GOOGLE-VORSCHAU',
    noDescription: 'Keine Beschreibung.',
    catHeroLayout: 'Hero & Layout',
    catContent: 'Inhalt',
    catFeaturesData: 'Funktionen & Daten',
    catSocialProof: 'Sozialer Beweis',
    catCta: 'Handlungsaufforderung',
    catDocuments: 'Dokumente & Rechtliches',
    catOther: 'Sonstiges',
    missing: 'Fehlt',
    add: 'Hinzufügen',
    addItem: 'Element hinzufügen',
    item: 'Element',
    notStarted: 'Nicht begonnen',
  },
  userOverride: {
    title: 'Benutzerkontoüberschreibung',
    infoBannerTitle: 'Überschreibungen auf Benutzerebene (Ebene 1)',
    infoBannerDesc: 'Diese Einstellungen überschreiben die Gruppenstandards. Leer lassen (NULL) für Gruppeneinstellungen.',
    sectionTradingControl: 'Handelskontrolle',
    sectionRiskParameters: 'Risikoparameter',
    sectionPricingOverrides: 'Preisüberschreibungen',
    disableTrading: 'Handel deaktivieren',
    disableTradingSubLabel: 'Diesen Benutzer daran hindern, neue Positionen zu eröffnen',
    resetToGroupDefault: 'Auf Gruppenstandard zurücksetzen',
    groupDefault: 'Gruppenstandard',
    maxLeverage: 'Maximaler Hebel',
    maxLotSize: 'Maximale Lotgröße',
    minLotSize: 'Minimale Lotgröße',
    marginCallLevel: 'Margin-Call-Level (%)',
    stopOutLevel: 'Stop-Out-Level (%)',
    maxOpenPositions: 'Maximale offene Positionen',
    commissionPerLot: 'Provision pro Lot (USD)',
    commissionPerLotHint: 'USD pro gehandeltem Standardlot',
    minAboveMaxError: '⚠️ Mindestgröße darf maximale Lotgröße nicht überschreiten',
    currentOverrideTitle: 'Aktive Überschreibung',
    currentOverrideDesc: 'Dieser Benutzer hat benutzerdefinierte Einstellungen, die Gruppenstandards überschreiben.',
    saveOverride: 'Überschreibung speichern',
    saving: 'Speichern...',
    saveSuccess: 'Benutzerüberschreibung erfolgreich gespeichert',
    saveFailed: 'Überschreibung konnte nicht gespeichert werden',
    lots: 'Lots',
    lotStep: 'Losgröße Schritt',

  },
  symbolSettings: {
    sectionPricing: 'Broker-Preise',
    sectionRisk: 'Risikolimits',
    sectionExecution: 'Ausführungsregeln',
    sectionOverrides: 'Instrument-Überschreibungen',
    sectionsLabel: 'Abschnitte',
    pricingDesc: 'Anpassungen auf Rohsätze des Instruments.',
    riskDesc: 'Positions- und Hebellimits auf Broker-Ebene.',
    executionDesc: 'Einschränkungen bei Auftragsplatzierung und -änderung.',
    overridesDesc: 'Jedes Feld aktivieren für Broker-Überschreibung.',
    overridesInfoTitle: 'Swap Long / Swap Short',
    overridesInfoDesc: 'Ersetzt den Instrument-Satz vollständig wenn aktiviert.',
    settingsTitle: '{symbol} Einstellungen',
    headerSubtitle: 'Preise und Risiken auf Broker-Ebene konfigurieren (Ebene 3)',
    overrideActive: '{count} Überschreibung aktiv',
    overridesActive: '{count} Überschreibungen aktiv',
    spreadMarkup: 'Spread-Aufschlag',
    spreadMarkupHint: 'Pips zum Rohspread hinzugefügt',
    commissionPerLot: 'Provision pro Lot',
    commissionPerLotHint: 'USD pro gehandeltem Standardlot',
    swapMarkup: 'Swap-Aufschlag',
    swapMarkupHint: 'Punkte zu Instrument-Swap-Sätzen hinzugefügt.',
    tripleSwapDay: 'Dreifacher Swap-Tag',
    tripleSwapDayHint: 'Tag, an dem dreifacher Swap berechnet wird',
    maxLeverage: 'Maximaler Hebel',
    maxLeverageHint: 'Maximaler Hebel für dieses Symbol',
    maxLotSize: 'Maximale Lotgröße',
    maxLotSizeHint: 'Maximale Positionsgröße pro Trade',
    minLotSize: 'Minimale Lotgröße',
    minLotSizeHint: 'Minimale Positionsgröße pro Trade',
    minAboveMaxError: '⚠️ Mindestgröße darf maximale Lotgröße nicht überschreiten',
    stopLevel: 'Stop-Level',
    stopLevelHint: 'Minimaler SL/TP-Abstand (Pips)',
    freezeLevel: 'Freeze-Level',
    freezeLevelHint: 'Abstand für Auftragsänderungen einfrieren (Pips)',
    contractSize: 'Kontraktgröße',
    contractSizeHint: 'Einheiten pro Lot.',
    priceScale: 'Preisskala',
    priceScaleHint: 'Dezimalstellen für Preisnotierung.',
    swapLong: 'Swap Long (direkter Satz)',
    swapLongHint: 'Overnight-Satz für KAUF-Positionen.',
    swapShort: 'Swap Short (direkter Satz)',
    swapShortHint: 'Overnight-Satz für VERKAUF-Positionen.',
    swapMode: 'Swap-Modus',
    swapModeHint: 'Berechnung des Overnight-Swap-Satzes',
    maxVolume: 'Maximales Volumen (Lots)',
    maxVolumeHint: 'Maximale Einzelhandelsgröße in Lots.',
    volumeStep: 'Volumenschritt (Lots)',
    volumeStepHint: 'Minimales Handelsgrößeninkrement.',
    defaultBadge: 'Standard',
    pips: 'Pips',
    pts: 'Pkt.',
    lots: 'Lots',
    decimals: 'Dezimalstellen',
    dayMon: 'Mo',
    dayTue: 'Di',
    dayWed: 'Mi',
    dayThu: 'Do',
    dayFri: 'Fr',
    daySat: 'Sa',
    daySun: 'So',
    loadingSettings: 'Einstellungen werden geladen...',
    saveSettings: 'Einstellungen speichern',
    lotStep: 'Losgröße Schritt',
  },
  accountGroupForm: {
    sectionsLabel: 'Abschnitte',
    sectionBasic: 'Grundinformationen',
    sectionPricing: 'Preisüberschreibungen',
    sectionRisk: 'Risikomanagement',
    editTitle: 'Kontogruppe bearbeiten',
    createTitle: 'Kontogruppe erstellen',
    basicInfoTitle: 'Grundinformationen',
    groupNameLabel: 'Gruppenname *',
    groupNamePlaceholder: 'Standardgruppe',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Gruppenbeschreibung...',
    groupActive: 'Gruppe aktiv',
    defaultGroup: 'Standardgruppe',
    pricingTitle: 'Preisüberschreibungen',
    pricingDesc: 'Leer lassen für Broker-Standardwerte.',
    commissionPerLot: 'Provision pro Lot (USD)',
    commissionPerLotHint: 'USD pro gehandeltem Standardlot',
    maxLeverage: 'Maximaler Hebel',
    maxLeverageHint: 'Maximaler Hebel für diese Gruppe',
    brokerDefault: 'Broker-Standard',
    resetToNoLimit: 'Auf kein Limit zurücksetzen',
    riskTitle: 'Risikomanagement',
    marginCallLevel: 'Margin-Call-Level',
    marginCallHint: 'Warnung wenn Margin-Level diesen Prozentsatz erreicht',
    stopOutLevel: 'Stop-Out-Level',
    stopOutHint: 'Automatisches Schließen bei diesem Margin-Level',
    maxOpenPositions: 'Maximale offene Positionen',
    maxOpenPositionsHint: 'Maximale Anzahl Positionen pro Konto',
    maxLotSize: 'Maximale Lotgröße',
    maxLotSizeHint: 'Maximale Lotgröße pro Trade',
    minLotSize: 'Minimale Lotgröße',
    minLotSizeHint: 'Minimale Lotgröße für diese Gruppe',
    noLimit: 'Kein Limit',
    lots: 'Lots',
    marginBelowStopError: '⚠️ Margin-Call muss größer als Stop-Out sein',
    minAboveMaxError: '⚠️ Mindestgröße darf maximale Lotgröße nicht überschreiten',
    updateGroup: 'Gruppe aktualisieren',
    createGroup: 'Gruppe erstellen',
    lotStep: 'Losgröße Schritt',
  },
  cryptoCheckout: {
    paymentConfirmedTitle: 'Zahlung bestätigt!',
    makePayment: 'Zahlung vornehmen',
    depositFunds: 'Einzahlen',
    purchaseItem: '{name} kaufen',
    subscribeTo: '{name} abonnieren',
    selectPaymentMethod: 'Zahlungsmethode wählen',
    payWith: 'Bezahlen mit {currencies}',
    creatingPayment: 'Zahlung wird erstellt...',
    continue: 'Weiter',
    sendExactly: 'Genau senden',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'QR-Code ausblenden',
    showQrCode: 'QR-Code anzeigen',
    scanWithWallet: 'Mit mobilem Wallet scannen',
    toThisAddress: 'An diese {network}-Adresse',
    expiresIn: 'Läuft ab in',
    waitingForPayment: 'Warte auf Zahlung...',
    waitingDesc: 'Genauen Betrag senden. Wird automatisch erkannt.',
    verifiedOnChain: 'On-Chain verifiziert von AmorPay.',
    pluginActivated: '{name} wurde aktiviert.',
    depositCredited: 'Einzahlung wurde gutgeschrieben.',
    subscriptionActive: 'Abonnement ist jetzt aktiv.',
    paymentConfirmed: 'Zahlung wurde bestätigt.',
    done: 'Fertig',
    noItemSelected: 'Kein Artikel ausgewählt',
    failedToLoadOptions: 'Zahlungsoptionen konnten nicht geladen werden',
  },
  subscriptionGate: {
    accountSuspended: 'Konto gesperrt',
    subscriptionExpired: 'Abonnement abgelaufen',
    suspendedDesc: 'Ihr Konto wurde gesperrt. Support kontaktieren.',
    expiredDesc: 'Ihr {plan}-Abonnement ist abgelaufen. Verlängern Sie für vollständigen Zugang.',
    renewSubscription: 'Abonnement verlängern',
    signOut: 'Abmelden',
    needHelp: 'Hilfe benötigt? Kontaktieren Sie',
    lastChance: '⚠️ Letzte Chance! Ihr {plan}-Abonnement ist abgelaufen. Zugang endet heute.',
    gracePeriodDay: 'Ihr {plan}-Abonnement ist abgelaufen. Noch {days} Tag verbleibend.',
    gracePeriodDays: 'Ihr {plan}-Abonnement ist abgelaufen. Noch {days} Tage verbleibend.',
    renewNow: 'Jetzt verlängern',
  },
  upgradePage: {
    renewTitle: 'Abonnement verlängern',
    upgradeTitle: 'Plan upgraden',
    currentlyOn: 'Aktuell auf',
    graceDaysLeft: '{days} Tag verbleibend',
    graceDaysLeftPlural: '{days} Tage verbleibend',
    expired: 'Abgelaufen',
    graceWarning: 'Abonnement abgelaufen. Noch {days} Tag zum Verlängern.',
    graceWarningPlural: 'Abonnement abgelaufen. Noch {days} Tage zum Verlängern.',
    expiredWarning: 'Abonnement vollständig abgelaufen. Jetzt verlängern.',
    renewOrUpgrade: 'Aktuellen Plan verlängern oder auf höhere Stufe upgraden.',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    mostPopular: 'Am beliebtesten',
    currentPlan: 'Aktueller Plan',
    perMonth: '/Monat',
    saveYearly: '10% sparen — ${amount}/Jahr abgerechnet',
    unlimitedTraders: 'Unbegrenzte Händler',
    tradersCount: '{count} Händler',
    unlimitedAdmins: 'Unbegrenzte Admins',
    adminsCount: '{count} Admins',
    unlimitedInstruments: 'Unbegrenzte Instrumente',
    instrumentsCount: '{count} Instrumente',
    feedUltra: 'Ultra-Niedrig-Latenz-Feed',
    feedPriority: 'Prioritäts-Feed',
    feedStandard: 'Standard-Feed',
    fullApiAccess: 'Vollständiger API-Zugang',
    selected: 'Ausgewählt',
    selectPlan: 'Plan auswählen',
    fullComparison: 'Vollständiger Vergleich',
    featureCol: 'Funktion',
    featureTraders: 'Händler',
    featureAdmins: 'Admins',
    featureInstruments: 'Instrumente',
    featureFeedLatency: 'Feed-Latenz',
    featureApiAccess: 'API-Zugang',
    featureForex: 'Forex',
    featureCrypto: 'Krypto',
    featureCommodities: 'Rohstoffe',
    featureIndices: 'Indizes',
    featureStocks: 'Aktien',
    selectedPlan: 'Ausgewählter Plan:',
    selectToContinue: 'Plan auswählen um fortzufahren',
    perYear: '/Jahr',
    renewNow: 'Jetzt verlängern',
    upgradeNow: 'Jetzt upgraden',
    failedToLoadPlans: 'Pläne konnten nicht geladen werden',
    selectPlanFirst: 'Bitte zuerst einen Plan auswählen',
    planActivated: '{name}-Plan aktiviert! 🎉',
  },
  sidebar: {
    sectionOverview: 'Übersicht',
    sectionManagement: 'Verwaltung',
    sectionTrading: 'Handel',
    sectionFinance: 'Finanzen',
    sectionPlugins: 'Plugins',
    sectionSystem: 'System',
    accountGroups: 'Kontogruppen',
    cascadeGuide: 'Kaskaden-Leitfaden',
    pluginStore: 'Plugin-Store',
    kycVerification: 'KYC-Verifizierung',
    kycDashboard: 'KYC-Dashboard',
    kycConfig: 'KYC-Konfiguration',
    pages: 'Seiten',
    credits: 'Guthaben',
    emailTemplates: 'E-Mail-Vorlagen',
    restApi: 'REST API',
    advancedAnalytics: 'Erweiterte Analytik',
    descClients: 'Benutzer · Einstellungen · Überschreibungen',
    descGroups: 'Gruppen · Einstellungen · Überschreibungen',
    descInstruments: 'Broker · Einstellungen · Überschreibungen',
    descAccounts: 'Konten & Salden',
    descCascade: 'Prioritätssystem erklärt',
    descAnalytics: 'KI-gestützte Einblicke',
    badgeLive: 'Live',
    badgeActive: 'Aktiv',
    badgeAddon: 'Erweiterung',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Konfig',
    badgeHowItWorks: 'So funktioniert es',
    cascadeTipFallthrough: 'Felder leer lassen, um zur nächsten Ebene durchzufallen',
  },
};